import React, { useEffect, useState } from 'react';
import { GoogleMap, Marker, OverlayView, useJsApiLoader } from '@react-google-maps/api';
import { useSearchParams } from 'react-router-dom';
import { GetEmail } from '../../../Api/getData';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { HiLocationMarker, HiClock } from 'react-icons/hi';

dayjs.extend(utc);

const Maps = ({ dataSource }) => {

    const [searchParams] = useSearchParams();
    // const KodeCabang = searchParams.get("KodeCabang") ? searchParams.get("KodeCabang") : "SGM";
    const ShipCode = searchParams.get("ShipCode") ? searchParams.get("ShipCode") : "G2008";

    const { isLoaded, loadError } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyDgCJRdIE3hpeL8oR9IP5LQQrzn6Olb-Ow",
        preventGoogleFontsLoading: true
    });

    // const [dataAPI, setDataAPI] = useState(null);
    const [dataEmail, setDataEmail] = useState(null);

    // const DateAPI = dataAPI ? dayjs.utc(dataAPI.RefDate).format('YYYY-MM-DD HH:mm:ss') : "";
    const DateEmail = dataEmail ? `${dataEmail.date} ${dataEmail.time}` : "";

    let Latitude = "";
    let Longitude = "";
    let LastDateMap = "";

    if (dataEmail && dataEmail.coordinates) {
        const filter = dataEmail.coordinates.split(', ');
        Latitude = filter[0];
        Longitude = filter[1];
        LastDateMap = DateEmail;
    } else {
        Latitude = -2.5489;
        Longitude = 118.0149;
        LastDateMap = dayjs().format("YYYY-MM-DD HH:mm:ss");
    }

    // if (DateAPI || DateEmail) {
    //     if (DateAPI > DateEmail) {
    //         // console.log("Date API");
    //         Latitude = dataAPI ? dataAPI.Value1 : '';
    //         Longitude = dataAPI ? dataAPI.Value2 : '';
    //         LastDateMap = DateAPI
    //     } else {
    //         // console.log("Date Email");
    //         const filter = dataEmail && dataEmail.coordinates ? dataEmail.coordinates.split(', ') : '';
    //         Latitude = filter[0];
    //         Longitude = filter[1];
    //         LastDateMap = DateEmail;
    //     }
    // } else {
    //     Latitude = -6.200000;
    //     Longitude = 106.816666;
    //     LastDateMap = dayjs().format("YYYY-MM-DD HH:mm:ss");
    // }

    useEffect(() => {
        if (dataSource) {
            // const response = dataSource.filter((item) => item.DisplayNo === 1);
            // if (response.length > 0) {
            //     const res = response.find((item) => item.SensorCode === ShipCode);
            //     setDataAPI(res);
            // }
            const fetchData = async (retryCount = 0) => {
                try {
                    const res = await GetEmail({ ObjectCode: ShipCode });
                    setDataEmail(res);

                } catch (error) {
                    setDataEmail(null);
                    if (retryCount < 5) {
                        setTimeout(() => fetchData(retryCount + 1), 1000);
                    }
                }
            };
            fetchData();

        }
    }, [ShipCode, dataSource]);


    // Default coordinates (Jakarta)
    const defaultLat = -2.5489;
    const defaultLng = 118.0149;

    if (loadError) {
        return (
            <div className="w-full h-[500px] lg:h-[600px] xl:h-[700px] flex flex-col gap-6">
                <div className="relative flex-1 rounded-2xl overflow-hidden bg-gray-100">
                    <div className="flex justify-center items-center h-full">
                        <div className="text-center">
                            <div className="w-16 h-16 bg-red-100 rounded-full mx-auto mb-4 flex items-center justify-center">
                                <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                                </svg>
                            </div>
                            <p className="text-red-600 font-semibold mb-2">Failed to load Google Maps</p>
                            <p className="text-sm text-gray-600">Please check your internet connection or disable ad blockers</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (!isLoaded) {
        return (
            <div className="w-full h-[500px] lg:h-[600px] xl:h-[700px] flex flex-col gap-6">
                {/* Loading Map */}
                <div className="relative flex-1 rounded-2xl overflow-hidden bg-gray-100 animate-pulse">
                    <div className="flex justify-center items-center h-full">
                        <div className="text-center">
                            <div className="w-16 h-16 bg-gray-300 rounded-full mx-auto mb-4 animate-spin"></div>
                            <p className="text-gray-500 font-semibold">Loading Maps...</p>
                            <p className="text-sm text-gray-400 mt-1">Initializing Google Maps</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const center = {
        lat: parseFloat(Latitude),
        lng: parseFloat(Longitude),
    };

    const handleMapLoad = (map) => {
        if (!Latitude || !Longitude) {
            // Jika tidak ada koordinat, center ke default location
            map.setCenter({ lat: defaultLat, lng: defaultLng });
        }
    };

    return (
        <div className="w-full h-[500px] lg:h-[600px] xl:h-[700px] flex flex-col gap-6">
            {/* Header dengan informasi koordinat */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                {/* Latitude Card */}
                <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-4 border border-blue-200 shadow-sm">
                    <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center">
                            <HiLocationMarker className="w-5 h-5 text-white" />
                        </div>
                        <div className="flex-1">
                            <p className="text-sm font-medium text-blue-600 uppercase tracking-wide">Latitude</p>
                            <p className="text-xl font-bold text-blue-900">
                                {center.lat ? center.lat.toFixed(6) : '0.000000'}
                            </p>
                        </div>
                    </div>
                </div>

                {/* Longitude Card */}
                <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-4 border border-green-200 shadow-sm">
                    <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-green-500 rounded-lg flex items-center justify-center">
                            <HiLocationMarker className="w-5 h-5 text-white" />
                        </div>
                        <div className="flex-1">
                            <p className="text-sm font-medium text-green-600 uppercase tracking-wide">Longitude</p>
                            <p className="text-xl font-bold text-green-900">
                                {center.lng ? center.lng.toFixed(6) : '0.000000'}
                            </p>
                        </div>
                    </div>
                </div>

                {/* Status Card */}
                <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-4 border border-purple-200 shadow-sm">
                    <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-purple-500 rounded-lg flex items-center justify-center">
                            <HiClock className="w-5 h-5 text-white" />
                        </div>
                        <div className="flex-1">
                            <p className="text-sm font-medium text-purple-600 uppercase tracking-wide">Status</p>
                            <p className="text-lg font-bold text-purple-900">
                                {dataEmail ? 'Live' : 'Default'}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Map Container */}
            <div className="relative flex-1 rounded-xl overflow-hidden shadow-2xl border-2 border-white/20">
                <GoogleMap
                    mapContainerStyle={{ width: '100%', height: '100%' }}
                    center={dataEmail ? center : { lat: defaultLat, lng: defaultLng }}
                    zoom={dataEmail ? 6 : 5}
                    onLoad={handleMapLoad}
                    options={{
                        mapTypeId: "hybrid"
                    }}
                // options={{
                //     styles: [
                //         {
                //             featureType: "water",
                //             elementType: "geometry",
                //             stylers: [
                //                 { color: "#1e3a8a" },
                //                 { lightness: 17 }
                //             ]
                //         },
                //         {
                //             featureType: "landscape",
                //             elementType: "geometry",
                //             stylers: [
                //                 { color: "#1f2937" },
                //                 { lightness: 20 }
                //             ]
                //         },
                //         {
                //             featureType: "road",
                //             elementType: "geometry",
                //             stylers: [
                //                 { color: "#374151" },
                //                 { lightness: 18 }
                //             ]
                //         },
                //         {
                //             featureType: "poi",
                //             elementType: "geometry",
                //             stylers: [
                //                 { color: "#4b5563" },
                //                 { lightness: 21 }
                //             ]
                //         }
                //     ],
                //     disableDefaultUI: false,
                //     zoomControl: true,
                //     mapTypeControl: true,
                //     scaleControl: true,
                //     streetViewControl: true,
                //     rotateControl: true,
                //     fullscreenControl: true
                // }}
                >
                    {dataEmail ? (
                        <>
                            <Marker
                                position={center}
                                icon={{
                                    url: "/assets/ship-z.png",
                                    scaledSize: new window.google.maps.Size(80, 80),
                                    anchor: new window.google.maps.Point(40, 40)
                                }}
                                title={dataEmail.Title}
                            />
                            <OverlayView
                                position={center}
                                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                            >
                                <div
                                    style={{
                                        position: 'absolute',
                                        transform: 'translate(-50%, 35px)',
                                        backgroundColor: 'white',
                                        padding: '4px 8px',
                                        borderRadius: '4px',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        color: 'black',
                                        whiteSpace: 'nowrap',
                                        boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                                        border: '1px solid rgba(0,0,0,0.1)',
                                        pointerEvents: 'none'
                                    }}
                                >
                                    {dataEmail.Title || "No Title"}
                                </div>
                            </OverlayView>
                        </>
                    ) : (
                        <Marker
                            position={{ lat: defaultLat, lng: defaultLng }}
                            icon={{
                                url: "/assets/ship-z.png",
                                scaledSize: new window.google.maps.Size(80, 80),
                                anchor: new window.google.maps.Point(40, 40)
                            }}
                        />
                    )}
                </GoogleMap>

                {/* Map Overlay Info */}
                {/* <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm rounded-lg p-3 shadow-lg border border-white/20">
                    <div className="flex items-center space-x-2">
                        <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
                        <span className="text-sm font-semibold text-gray-700">
                            {dataAPI && dataAPI.length > 0 ? 'Live Tracking' : 'Offline Mode'}
                        </span>
                    </div>
                </div> */}

                {/* Last Update Info */}
                {/* {LastDateMap && (
                    <div className="absolute bottom-4 left-4 bg-white/90 backdrop-blur-sm rounded-lg p-3 shadow-lg border border-white/20">
                        <div className="flex items-center space-x-2">
                            <HiClock className="w-4 h-4 text-gray-500" />
                            <div>
                                <p className="text-xs text-gray-500 font-medium">Last Update</p>
                                <p className="text-sm font-semibold text-gray-700">
                                    {new Date(LastDateMap).toLocaleString('id-ID', {
                                        year: 'numeric',
                                        month: 'short',
                                        day: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit'
                                    })}
                                </p>
                            </div>
                        </div>
                    </div>
                )} */}
            </div>
        </div >
    );
};

export default Maps;
